import { useQuery } from '@tanstack/react-query'
import { Table, Card, Tag, Space, Button, Modal } from 'antd'
import { StopOutlined, CheckCircleOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { getUsers, getUserData, type User } from '../api/admin'
import { useState } from 'react'

const Users = () => {
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [dataModalOpen, setDataModalOpen] = useState(false)
  const [dataLoading, setDataLoading] = useState(false)
  const [dataContent, setDataContent] = useState<any>(null)

  const { data, isLoading } = useQuery({
    queryKey: ['users', page, pageSize],
    queryFn: () => getUsers(page, pageSize).then((res) => res.data.data),
  })

  const handleViewData = async (record: User) => {
    try {
      setDataLoading(true)
      const res = await getUserData(record.app_id, record.user_id)
      setDataContent(res.data.data)
      setDataModalOpen(true)
    } catch {
      setDataContent({ error: '加载失败' })
      setDataModalOpen(true)
    } finally {
      setDataLoading(false)
    }
  }

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 80,
    },
    {
      title: '应用',
      dataIndex: 'app_name',
    },
    {
      title: '应用ID',
      dataIndex: 'app_id',
    },
    {
      title: '用户ID',
      dataIndex: 'user_id',
    },
    {
      title: '账户邮箱',
      dataIndex: 'account_email',
    },
    {
      title: '状态',
      dataIndex: 'status',
      render: (status: string) => (
        <Tag color={status === 'active' ? 'green' : 'red'}>
          {status === 'active' ? '活跃' : '已停用'}
        </Tag>
      ),
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      render: (date: string) => dayjs(date).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: User) => (
        <Space>
          <Button type="link" onClick={() => handleViewData(record)}>
            查看数据
          </Button>
          {record.status === 'active' ? (
            <Button type="link" danger icon={<StopOutlined />}>
              禁用
            </Button>
          ) : (
            <Button type="link" icon={<CheckCircleOutlined />}>
              启用
            </Button>
          )}
        </Space>
      ),
    },
  ]

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>用户管理</h2>
      <Card>
        <Table
          columns={columns}
          dataSource={data?.items || []}
          loading={isLoading}
          rowKey="id"
          pagination={{
            current: page,
            pageSize,
            total: data?.total || 0,
            onChange: (p, ps) => {
              setPage(p)
              setPageSize(ps || 20)
            },
          }}
        />
      </Card>
      <Modal
        title="用户扩展数据"
        open={dataModalOpen}
        onCancel={() => setDataModalOpen(false)}
        footer={null}
        width={800}
      >
        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
          {dataLoading ? '加载中...' : JSON.stringify(dataContent, null, 2)}
        </pre>
      </Modal>
    </div>
  )
}

export default Users
